import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

// Toastification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {});

// Services
import apiService from './services/api.service'
Vue.prototype.$request = apiService

import WebsocketPlugin from "./services/websocket.service";

Vue.use(WebsocketPlugin, {
    apiKey: "k89THg.0LgDvQ:IXNouoE4-i8vYB3c8cr-JtIfYndsZ5I-7XJBK5ZB1u0",
    channel: "get-started"
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
